import React from 'react';

//CSS
import './PullTypeSelector.css';

const PULL_TYPES = [
    { id: 'standard', label: 'Standard Pull', description: 'Credit Bureau branding' },
    { id: 'credo', label: 'Credo Legal', description: 'Branded with Credo Legal' },
];

/**
 * Elegant segmented toggle so the user can choose how credit reports are pulled.
 * "standard" keeps the current behavior; "credo" pulls a report branded with the
 * Credo Legal logo and from-information.
 *
 * @param {string}  value    Currently selected pull type id ('standard' | 'credo')
 * @param {function} onChange Callback invoked with the newly selected id
 */
export default function PullTypeSelector({ value, onChange }) {

    return (
        <div className="pullTypeSelector">
            <span className="pullTypeSelectorLabel">Credit Report Pull Type</span>
            <div className="pullTypeSelectorOptions" role="radiogroup" aria-label="Credit Report Pull Type">
                {PULL_TYPES.map((type) => (
                    <button
                        key={type.id}
                        type="button"
                        role="radio"
                        aria-checked={value === type.id}
                        className={`pullTypeOption ${value === type.id ? 'pullTypeOption--active' : ''}`}
                        onClick={() => onChange(type.id)}
                    >
                        <span className="pullTypeOptionLabel">{type.label}</span>
                        <span className="pullTypeOptionDesc">{type.description}</span>
                    </button>
                ))}
            </div>
        </div>
    );
}
